import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IIceCatReportStatusRequest, IIceCatReportStatusResponse } from '../models/models'

export class GetIceCatReportStatusApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/icecat/GetIceCatReportStatus',
      requesterInfo,
    })
  }

  public async getIceCatReportStatus(request: IIceCatReportStatusRequest): Promise<IIceCatReportStatusResponse[]> {
    return await this.postAsync<IIceCatReportStatusResponse[]>(request)
  }
}
